var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-radio"},[_c('DSRadioButton',{ref:"radio",staticClass:"c-radio__input",attrs:{"checked":_vm.checked,"name":_vm.name,"value":_vm.value,"type":"radio"}}),_c('label',{staticClass:"c-radio__label",attrs:{"for":_vm.radio}},[_c('DSTextElement',[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }